import script from "./PixelGame.vue?vue&type=script&setup=true&lang=js"
export * from "./PixelGame.vue?vue&type=script&setup=true&lang=js"

import "./PixelGame.vue?vue&type=style&index=0&id=4ae3def2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae3def2"]])

export default __exports__